import { Component, Element, Event, EventEmitter, h, Host } from "@stencil/core";

@Component({
    tag: "uic-segmented-control",
    styleUrl: "segmented-control.scss"
})
export class SegmentedControl {
    @Element() host: HTMLUicSegmentedControlElement;

    /** Emitted with the value attribute/prop of a segment (button) when it's clicked */
    @Event({ eventName: "uicChange" }) change: EventEmitter<string>;

    private handleClick(e) {
        const selectedButton = e.target.parentElement;
        const value = selectedButton.value || selectedButton.getAttribute("value");
        if (value == null || value === "") {
            return;
        }
        this.change.emit(value);

        const buttons = this.getSelectedButtons();
        buttons.forEach((b) => (b.selected = false));

        e.target.parentElement.selected = true;
    }

    private getSelectedButtons(): Array<HTMLUicButtonElement> {
        return [...this.host.querySelectorAll<HTMLUicButtonElement>("uic-button[selected]")];
    }

    render() {
        return (
            <Host class='uic-segmented-control' onClick={(e) => this.handleClick(e)}>
                <slot></slot>
            </Host>
        );
    }
}
